// @flow

import React, { useEffect } from 'react';
import classNames from 'classnames';

import beeImage from 'assets/client/images/bee_pop-up.svg';
import * as css from './InfoPopUp.scss';

type Props = {
	className?: string,
	closePopUp: Function,
};

const InfoPopUp = ({ closePopUp, className }: Props) => {
	const text = 'הדירוג שלך התקבל, תודה';

	useEffect(() => {
		setTimeout(() => {
			closePopUp(null);
		}, 2000);
	}, []);

	return (
		<div className={classNames(css.infoPopUp, className)}>
			<div className={css.content}>
				<img src={beeImage} alt="bee_pop-up" />
				<p className={css.text}>{text}</p>
			</div>
		</div>
	);
};

InfoPopUp.defaultProps = {
	className: '',
};

export default InfoPopUp;
